import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { Input } from '@fortem-monorepo/react-ui'

export interface SedolFieldProps {}

export const SedolField: React.FC<SedolFieldProps> = ({}) => {
  const { control, register } = useFormContext<{ sedol: string }>()

  return (
    <FormField
      name="sedol"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2 overflow-hidden">
              <FormLabel>SEDOL</FormLabel>
              <FormError />
            </div>
            <Input {...register('sedol')} placeholder={'Enter a sedol'} />
          </FormItem>
        )
      }}
    />
  )
}
